import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ConsultaService } from '../../services/consulta.service';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  private _success = new Subject<string>();

  staticAlertClosed = false;
  successMessage = '';

  login: any;
  user: any;
  usuario: any = {
    login: "",
    clave: "",
    Token: ""
  };
  Token: any;
  jwt: any;
  cargando = 0;
  constructor(private auth: AuthService, private consulta: ConsultaService, private router: Router) { }



  ngOnInit(): void {
    setTimeout(() => this.staticAlertClosed = true, 20000);

    this._success.subscribe(message => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = '');
  }

  registrar() {
    this.router.navigate(['/registro']);
  }
  token() {
    //Inicio de sesión en Marsed Agua Quito
    var filtroInicioSesion = {
      "email": "admin",
      "password": "M4rs3d*2021L"
    }
    this.auth.loginChirp(filtroInicioSesion).subscribe(
      result => {

        this.jwt = result.jwt;
        //localStorage.setItem("jwt", this.jwt);
        //this.login.Token = this.jwt.UsuarioLoginResult.Token;
        this.auth.setTokenJwt(this.jwt);
        // console.log("esto buscas"+result);
        //this.router.navigate(['/obtener-datos']);

      }, error => console.log(error));

  }
  onSubmit(usuario) {

    //this.consulta.alertSpinner();
    this.cargando = 1;
    this.auth.loginuser(usuario.login, usuario.clave).subscribe(
      result => {
        console.log(result);
        this.login = result;
        this.cargando = 0;
        //  this.consulta.closeSweet();
        if (this.login.length == 1) {
          Swal.fire(
            'Ingreso!',
            'Credenciales correctas.',
            'success'
          )

          var usuarioActual = {
            id: this.login[0].Id,
            login: this.login[0].Login,
            tipo: this.login[0].Tipo
          }
          this.auth.setUsuarioActual(usuarioActual);


          if (this.login[0].Tipo == "C") {
            localStorage.setItem("codcliente", this.login[0].CodLector);
            localStorage.setItem("tipo", this.login[0].Tipo);
            this.router.navigate(['autofacturacion/listado']);
          } else if (this.login[0].Tipo == "A") {
            this.consulta.setCodigoLector(this.login[0].CodLector);
            //Inicio de sesión en Marsed Agua Quito
            var filtroInicioSesion = { Login: "admin", Clave: "Frameworks.1" }
            this.auth.loginAgua(filtroInicioSesion).subscribe(
              result => {
                this.Token = result;
                this.login.Token = this.Token.UsuarioLoginResult.Token;
                this.auth.setToken(this.login.Token);

                this.router.navigate(['/obtener-datos']);

              }, error => console.log(error));
          } else if (this.login[0].Tipo == "Q") {
            localStorage.setItem("tipo", this.login[0].Tipo);
            this.router.navigate(['autofacturacion/listado']);

          } else if (this.login[0].Tipo == "L") {
            localStorage.setItem("tipo", this.login[0].Tipo);
            this.router.navigate(['/dashboard']);
          }
          else if (this.login[0].Tipo == "I") {
            //Inicio de sesión en Marsed Agua Quito
            var filtroInicioSesion = { Login: "admin", Clave: "Frameworks.1" }
            var filtroInicioSesionC = { "email": "admin", "password": "M4rs3d*2021L" }

            /* this.auth.loginChirp(filtroInicioSesionC).subscribe(
             result => {
             this.jwt = result.jwt;*/
            //localStorage.setItem("jwt", this.jwt);
            //this.login.Token = this.jwt.UsuarioLoginResult.Token;

            // this.auth.setTokenJwt(this.jwt); este
            // this.auth.setTokenJwt(token); 
            // console.log("esto buscas"+result);
            //this.router.navigate(['/obtener-datos']);

            // }, error => console.log(error));
            this.auth.loginAgua(filtroInicioSesion).subscribe(
              result => {
                this.Token = result;

                this.login.Token = this.Token.UsuarioLoginResult.Token;
                this.auth.setToken(this.login.Token);
                this.router.navigate(['/dashboard']);
                localStorage.setItem("tipo", this.login[0].Tipo);
                //this.router.navigate(['/obtener-datos']);


              }, error => console.log(error));

          } else if (this.login[0].Tipo == "E") {
            //Inicio de sesión en Marsed Agua Quito
            var filtroInicioSesion = { Login: "admin", Clave: "Frameworks.1" }
            var filtroInicioSesionC = { "email": "admin", "password": "M4rs3d*2021L" }
            this.auth.loginChirp(filtroInicioSesionC).subscribe(
              result => {
                this.jwt = result.jwt;
                this.auth.setTokenJwt(this.jwt);
              }, error => console.log(error));
            this.auth.loginAgua(filtroInicioSesion).subscribe(
              result => {
                this.Token = result;
                this.login.Token = this.Token.UsuarioLoginResult.Token;
                this.auth.setToken(this.login.Token);
                localStorage.setItem("tipo", this.login[0].Tipo);
                this.router.navigate(['/dashboard']);
              }, error => console.log(error));
          }
          else if (this.login[0].Tipo == "G") {
            console.log("Usuario de gas");
            localStorage.setItem("tipo", this.login[0].Tipo);
            this.router.navigate(['/dashboard']);
          }
          else {
            this.router.navigate(['/']);
          }
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Error al ingresar',
            footer: 'Usuario o Contraseña Incorrecta.'
          })
          this._success.next('Error.');
        }
      },
      error => console.log(error));
  }



}
